import {StatusService} from '../../../shared/services/authentication/status.service';
import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AnalyticsService} from '../../../shared/services/analytics/analytics.service';
import {EventEnum, PathUrlEnum} from '../../../utils/analytics.utils';

import {IProposal} from '../../../shared/interfaces/IProposal';
import {DataPersonalSellerPf} from '../../../shared/models/SellerPf.model';
import {FormsService} from '../../../shared/services/form/forms.service';
import {RouteUtils} from "../../../utils/route.utils";
import {EstadoCivil} from "../../../shared/enums/estadoCivil.enum";
import {formatToIsoDate} from "../../../utils/date.utils";
import {emptyStringToNull} from "../../../utils/seller-pf-mapper.util";

@Component({
  selector: 'app-seller-shell-pf',
  templateUrl: './seller-shell-pf.component.html',
  styleUrls: ['./seller-shell-pf.component.scss'],
})
export class SellerShellPfComponent implements OnInit {
  dataPersonal = new DataPersonalSellerPf();
  proposal: IProposal;
  totalSteps = 3;
  currentStep = 1;
  buttonDisabled = true;
  showError = false;
  errorMessage = '';
  showErrorFormsService = false;
  showModalExit = false;
  loadingSaveForm = false;

  percent = (100 / this.totalSteps) * this.currentStep;

  constructor(
    private _router: Router,
    private formsService: FormsService,
    private statusService: StatusService,
    private analyticsService: AnalyticsService,
  ) {
  }

  ngOnInit(): void {
    this.getParticipant();
    this.isParticipate();
  }

  private getParticipant() {
    const participantValues = this.formsService.getNameAndDocument();
    if (!participantValues?.documentNumber) {
      this.showError = true;
      this.errorMessage = 'Não foi possível carregar as informações de nome e CPF';
      return;
    }
    this.dataPersonal.name = participantValues.name;
    this.dataPersonal.documentNumber = participantValues.documentNumber;
  }

  private getCurrentCustomPath(): PathUrlEnum {
    switch (this.currentStep) {
      case 1:
        return PathUrlEnum.PROPRIETARIO_PF_DADOS_PESSOAIS;
      case 2:
        return this.hasParticipant()
          ? PathUrlEnum.PROPRIETARIO_PF_DADOS_CONJUGE
          : PathUrlEnum.PROPRIETARIO_PF_DADOS_PAGAMENTO;
      case 3:
        return this.hasParticipant()
          ? PathUrlEnum.PROPRIETARIO_PF_DADOS_PAGAMENTO
          : PathUrlEnum.PROPRIETARIO_PF_RESUMO;
      case 4:
        return PathUrlEnum.PROPRIETARIO_PF_RESUMO;
      default:
        return PathUrlEnum.PROPRIETARIO_PF_DADOS_PESSOAIS;
    }
  }

  focusFirstElement() {
    document.getElementById('backButton')?.focus();
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }

  backStep() {
    this.analyticsService.trackEvent(this.getCurrentCustomPath(), EventEnum.BTN_VOLTAR);
    if (this.currentStep <= 1) {
      this.showModalExit = true;
    } else {
      this.focusFirstElement();
      this.currentStep--;
      this.percent = (100 / this.totalSteps) * this.currentStep;
    }
  }

  navigateFormList(): void {
    this._router.navigateByUrl(RouteUtils.PAGES.FORM_LIST);
  }

  goToNextStep() {
    this.analyticsService.trackEvent(this.getCurrentCustomPath(), EventEnum.BTN_CONTINUAR);
    this.isParticipate();
    this.focusFirstElement();
    if (this.currentStep < this.totalSteps) {
      this.currentStep++;
      this.buttonDisabled = true;
      this.percent = (100 / this.totalSteps) * this.currentStep;
    }
  }

  hasParticipant() {
    return (
      this.dataPersonal.relationship.hasStableUnion ||
      this.dataPersonal.relationship.maritalStatus === EstadoCivil.CASADO
    );
  }

  isParticipate() {
    if (this.hasParticipant()) {
      this.totalSteps = 4;
    } else {
      this.totalSteps = 3;
    }
  }

  receiverFormsStatus(reciverForms: boolean) {
    this.buttonDisabled = !reciverForms;
  }

  receiverDataForms(data: DataPersonalSellerPf) {
    this.dataPersonal = data;
  }

  formatSellerData(data: DataPersonalSellerPf): DataPersonalSellerPf {
    const clone: DataPersonalSellerPf = emptyStringToNull(JSON.parse(JSON.stringify(data)));
    clone.name = clone?.name?.trim();

    clone.birth.date = formatToIsoDate(clone.birth.date);
    clone.relationship.marriageDate = formatToIsoDate(clone.relationship.marriageDate);
    clone.document.issueDate = formatToIsoDate(clone.document.issueDate);

    clone.payment.accountDigit = clone.payment.accountNumber.replace(/-/g, '').slice(-1);
    clone.payment.accountNumber = clone.payment.accountNumber.replace(/-/g, '').slice(0,-1);
    clone.payment.agencyNumber = clone.payment.agencyNumber.replace(/-/g, '');
    clone.parentage.motherName = clone.parentage.motherName?.trim();
    if(clone.parentage.fatherName){
      clone.parentage.fatherName = clone.parentage?.fatherName?.trim();
    }
    if(clone.attorneyData?.fullName){
        clone.attorneyData.fullName = clone.attorneyData?.fullName?.trim();
    }
    if (clone.partner) {
      clone.partner.name = clone.partner.name?.trim();
      clone.partner.birth.date = formatToIsoDate(clone.partner.birth.date);
      clone.partner.document.issueDate = formatToIsoDate(clone.partner.document.issueDate);

          clone.partner.parentage.motherName = clone.partner.parentage.motherName?.trim();
    if(clone.partner.parentage.fatherName){
      clone.partner.parentage.fatherName = clone.partner.parentage?.fatherName?.trim();
    }
    if(clone.partner.attorneyData?.fullName){
        clone.partner.attorneyData.fullName = clone.partner.attorneyData?.fullName?.trim();
    }

      if (clone.partner.payment) {
        clone.partner.payment.accountDigit = clone.partner.payment.accountNumber.replace(/-/g, '').slice(-1);
        clone.partner.payment.accountNumber = clone.partner.payment.accountNumber.replace(/-/g, '').slice(0,-1);
        clone.partner.payment.agencyNumber = clone.partner.payment.agencyNumber.replace(/-/g, '');
      }

      if (!clone.partner?.deliveryAddress?.zipCode) delete clone.partner.deliveryAddress;
      if (!clone.partner?.attorneyData?.documentNumber) delete clone.partner.attorneyData;
    }

    if (!clone?.deliveryAddress?.zipCode) delete clone.deliveryAddress;
    if (!clone?.attorneyData?.documentNumber) delete clone.attorneyData;

    return clone;
  }

  submitFormsPf() {
    this.analyticsService.trackEvent(PathUrlEnum.PROPRIETARIO_PF_RESUMO, EventEnum.BTN_SALVAR_FORMULARIO);
    this.loadingSaveForm = true;
    this.formsService.postFormSellerPf(this.formatSellerData(this.dataPersonal)).subscribe({
      error: err => {
        this.loadingSaveForm = false;
        this.showError = true;
        this.errorMessage = err.error.errors
          ? err.error.errors[0].message
          : 'Não foi possível processar o checklist';
        this.showErrorFormsService = true;
      },
      complete: () => {
        this.loadingSaveForm = false;
        this.statusService.showToast('success', 'formulário de dados pessoais salvo');
        this._router.navigateByUrl(RouteUtils.PAGES.FORM_LIST);
      },
    });
  }

  reciverTryAgain() {
    this.showErrorFormsService = false;
  }
}
